import { useState, useEffect } from 'react';
import { getImageUrl, DEFAULT_LOGO_URL } from '../utils/imageUrlHelper';

const useDynamicLogo = () => {
  const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO_URL);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadLogo = async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
          setIsLoading(false);
          return;
        }

        // El logo se carga dinámicamente desde el selector de empresas
        // Por defecto usamos el logo genérico hasta que se seleccione una empresa
        setLogoUrl(DEFAULT_LOGO_URL);
        setIsLoading(false);
      } catch (error) {
        setLogoUrl(DEFAULT_LOGO_URL);
        setIsLoading(false);
      }
    };

    loadLogo();

    const handleLogoUpdate = (event) => {
      if (event.detail && event.detail.logoUrl) {
        setLogoUrl(getImageUrl(event.detail.logoUrl));
      } else {
        setLogoUrl(DEFAULT_LOGO_URL);
      }
    };

    window.addEventListener('logoUpdated', handleLogoUpdate);

    return () => {
      window.removeEventListener('logoUpdated', handleLogoUpdate);
    };
  }, []);

  return { logoUrl, isLoading };
};

export default useDynamicLogo;

